<template>
  <a href="https://taptiq.com/" target="_blank" class="flex items-center gap-2">
    <t-text size="sm" color="gray">Powered by</t-text>
    <img v-if="theme === 'light'" src="@/assets/static/img/logo__branded.svg" class="w-20 h-6 icon icon-logo text-gray" />
    <img v-else src="@/assets/static/img/logo__branded-dark.svg" class="w-20 h-6 icon icon-logo text-gray" />
  </a>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 't-powered-by',
    computed: {
      ...mapGetters(['theme'])
    }
  }
</script>
